import trackMediaSettingsDialogSubmitted from './track-media-settings-dialog-submitted';
import trackMediaSettingsInputClicked from './track-media-settings-input-clicked';
import trackMediaSettingsOptionClicked from './track-media-settings-option-clicked';

export default {
  trackMediaSettingsDialogSubmitted,
  trackMediaSettingsInputClicked,
  trackMediaSettingsOptionClicked,
};
